import Vue from "vue";
import { withTenant, noTenant } from "./AuthHeader";
import { env } from "../config/env";

const apiUrl = env.CORE_API_URL + "/tenant";

class TenantService {
  findAllLocations() {
    return Vue.prototype.$axios.get(apiUrl + "/estados", {
      headers: noTenant()
    });
  }

  findAllPublicDetails(siglaEstado) {
    return Vue.prototype.$axios.get(apiUrl + "/detail/public", {
      params: {
        siglaEstado
      },
      headers: noTenant()
    });
  }
}

export default new TenantService();
